function ParseError(componentName, message) {
  this.name = 'ParseError';
  this.message = 'Parse error: ' + message + ' (' + componentName + ')';
}
ParseError.prototype = Object.create(Error.prototype);
ParseError.prototype.constructor = ParseError;

export default ParseError;
